<template>
    <v-card>
      <v-card-text>
        <v-row class="pa-5 align-center">
          <v-col cols="11">
            <v-row>
              <h2 class="font-weight-bold text-center">Nueva Empresa</h2>
            </v-row>
          </v-col>
        </v-row>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="4">
                <v-select label="Tipo Doc." :rules="inputRules" persistent-hint return-object variant="outlined"
              v-model="tipodoc" :items="usersOptions"></v-select>
            </v-col>
            <v-col cols="8">
              <v-text-field persistent-hint hint="* Presione Enter para buscar" max-leng v-model="numero" @keyup="validaRazon" :rules="lenRules" label="Num. Doc" variant="outlined"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="razonsocial" :rules="inputRules" label="Razon Social" :readonly="!activarControl" variant="outlined"></v-text-field>
            </v-col>
            <v-col cols="6">
                <v-text-field v-model="fecha" :rules="inputRules" label="Fecha Inicio" type="date"
              variant="outlined"></v-text-field>
            </v-col>
            <v-col cols="6">
                <v-text-field v-model="fechafin" label="Fecha Fin" type="date"
              variant="outlined" :rules="inputRules" ></v-text-field>
            </v-col>
          </v-row>
  
          <v-btn class="me-4" color="success" :loading="loading" :disabled="loading" depressed @mousedown="validate"
            @click="guardar">
            Guardar
          </v-btn>
          <v-btn class="me-4 text-white" color="error" to="/empresa">
            Regresar
          </v-btn>
          <v-snackbar v-model="snackbar" :timeout="3000" :color="snackbarColor">
            {{ snackbarText }}
          </v-snackbar>
  
        </v-form>
      </v-card-text>
    </v-card>
  </template>
  <script>
  
  export default {
    data() {
      return {
        token : null,
        loading: false,
        snackbarText: "",
        snackbar: false,
        snackbarColor: null,
        numero : "",
        razonsocial: "",
        fecha: null,
        fechafin: null,
        tipodoc: null,
        usersOptions: [],
        activarControl: false,
        valid: true,
        maxCaracteres: 11,
        minCaracteres: 8,
        inputRules: [
            (v) => !!v || "Campo requerido"
        ],
        lenRules: [
            (v) => !!v || "Campo requerido",
            (v) => /^\d+$/.test(v) || 'Ingresa solo números',
            (v) => (v || '').length <= this.maxCaracteres || `Maximo ${this.maxCaracteres} caracteres`,
            (v) => (v || '').length >= this.minCaracteres || `Minimo ${this.minCaracteres} caracteres`
        ],
  
      }
    },
    methods: {
      validate() {
        this.$refs.form.validate();
      },
  
      crearEntidad() {
        return {
          "numero": this.numero,
          "tipodoc": this.tipodoc.value,
          "descripcion": this.tipodoc.title,
          "razonsocial": this.razonsocial,
          "fecha": this.fecha,
          "fechafin": this.fechafin
        }
      },
      validaRazon(e){
        let valor = ""
        if (this.tipodoc != null) {
           valor = this.tipodoc.value;
        }
        if(e.which == 13){
            let url = valor == "1" ? '/users/dni/'+this.numero : '/users/ruc/'+this.numero;
            this.axios({
                headers : {
                  Authorization : "Bearer " + this.token
                },
                method : 'GET',
                url : url
            }).then(response => {
                this.razonsocial = response.data.razonsocial;
                this.loading = false;            
            }).catch(e => {
                this.razonsocial = "";
                if (e.hasOwnProperty("response")) {
                  this.snackbarText = e.response.data.message;  
                }else{
                  this.snackbarText = e.message;
                }
                this.snackbarColor = "error";
                this.snackbar = true;          
                this.loading = false;
            });
        }
        
      },
      guardar(){
        if (this.valid == false) return;
        this.loading = true;
        this.axios({
            headers : {
              Authorization : "Bearer " + this.token
            },
            method : 'POST',
            url : '/empresa',
            data: this.crearEntidad()
        }).then(response => {
            this.loading = false;            
            this.snackbarText = response.data.message;
            this.snackbarColor = "success";
            this.snackbar = true;    
            setTimeout(() => {
              this.$router.push('/empresa');
            }, 3000); 
        }).catch(e => {
          if (e.hasOwnProperty("response")) {
            this.snackbarText = e.response.data.message;  
          }else{
            this.snackbarText = e.message;
          }
          this.snackbarColor = "error";
          this.snackbar = true;          
          this.loading = false;
        })
      }
    },
    created(){
      this.token = localStorage.getItem("token");
      this.usersOptions = [
        {
          "title" : "RUC",
          "value" : "6"
        },
        {
          "title" : "DNI",
          "value": "1"
        }
      ]
    }
  }
  </script>
  <style lang="">
      
  </style>